import type { ReactNode } from 'react';

import { StyledTable } from './Table.styled';

type Props = {
  qaId?: string;
  headings: ReactNode[];
  trQaId?: string;
  data: ReactNode[][] | ReactNode[];
  initialIndex?: number;
  className?: string;
};

export function Table({
  headings,
  data,
  trQaId,
  initialIndex = 0,
  qaId,
  className,
}: Props) {
  return (
    <StyledTable data-qa-id={qaId} className={className}>
      <thead>
        <tr>
          {headings.map((heading, index) => (
            // TODO: Fix this the next time the file is edited.
            // oxlint-disable-next-line react/no-array-index-key
            <th key={index}>{heading}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {data.map((row, rindex) => (
          <tr // oxlint-disable-next-line react/no-array-index-key
            key={rindex}
            data-qa-id={trQaId}
            data-row-index={rindex + initialIndex}
          >
            {Array.isArray(row)
              ? row.map((cell, index) => (
                  <td // oxlint-disable-next-line react/no-array-index-key
                    key={index}
                  >
                    {cell}
                  </td>
                ))
              : row}
          </tr>
        ))}
      </tbody>
    </StyledTable>
  );
}
